export class AuthUser {
  getToken() {
    return localStorage.getItem("userToken");
  }

  getDetails() {
    return JSON.parse(localStorage.getItem("user"));
  }
}
